import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  NavigateFunction,
  RouterProvider,
  createBrowserRouter,
  useNavigate,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { Auth } from "./Auth";
import { Accounts } from "./Accounts";
import * as Sentry from "@sentry/react";
import { validateThemes, ThemeProvider } from "./theme";

Sentry.init({
  dsn: "https://875aff2af2d91b96c8ff4fe6fcba094e@o4507173510381568.ingest.us.sentry.io/4507173512216576",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  enabled: process.env.NODE_ENV !== "development",
  // I don't need session replays
  // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  // replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});

export let navigate: NavigateFunction;
function RouteWrapper({ children }: { children: React.ReactElement }) {
  navigate = useNavigate();
  return children;
}

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <RouteWrapper>
        <App />
      </RouteWrapper>
    ),
  },
  {
    path: "/auth",
    element: (
      <RouteWrapper>
        <Auth />
      </RouteWrapper>
    ),
  },
  {
    path: "/accounts",
    element: (
      <RouteWrapper>
        <Accounts />
      </RouteWrapper>
    ),
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <QueryClientProvider client={queryClient}>
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

validateThemes();
